import { Api } from '../api';
import { survey } from '../endpoints';
import { GetSurveyResponse, PostSurveyRequest } from './models';

export class SurveyApi extends Api {
  static getSurvey = (surveyId: string, clientId: string, signal?: AbortSignal) =>
    this.get<GetSurveyResponse>({ url: survey.getSurvey(surveyId, clientId), signal: signal });

  static getImage = (surveyId: string, clientId: string, signal?: AbortSignal) =>
    this.get<any>({ url: survey.getImgae(surveyId, clientId), signal: signal });

  static postSurvey = (request: PostSurveyRequest, surveyId: string, clientId: string, signal?: AbortSignal) =>
    this.post<PostSurveyRequest, any>({ url: survey.postSurvey(surveyId, clientId), data: request, signal: signal });
}
